import store from '@/store/index'

const snackbar = {
  show (data) {
    store.commit('snackbar/showMessage', data)
  },
  hide (data) {
    store.commit('snackbar/hideMessage')
  },
}

export default snackbar
